import type { GranularityLevel } from '../../../api/types.js';

/**
 * Platform field is required when granularity level is Placement folder ID.
 */
export function isPlatformFieldRequiredForTemplateDuplicate(
  granularityLevel: GranularityLevel,
): boolean {
  return granularityLevel === 'pricing_item';
}
